import { Link } from "react-router-dom";
// Cette page réutilise le gabarit d'état vide.
import "../components/EmptyState.css";

function NotFound() {
  return (
    <div className="container">
      <div className="pa-empty prose-center">
        <span className="pa-empty__icon" aria-hidden="true">
          <i className="bi bi-signpost-split"></i>
        </span>
        <h1 className="pa-empty__title">Cette page n'existe pas</h1>
        <p className="pa-empty__text">
          Le lien est peut-être périmé, ou l'événement a quitté l'affiche.
        </p>
        <div className="d-flex flex-wrap gap-2 justify-content-center">
          <Link to="/search" className="pa-btn pa-btn--primary">
            <i className="bi bi-search" aria-hidden="true"></i>
            Chercher un événement
          </Link>
          <Link to="/" className="pa-btn pa-btn--ghost">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
